import React, { useState } from "react";
import { Form, Icon, Input, Button, message, Spin } from "antd";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import DocumentTitle from "react-document-title";
import { reqSavePassword } from "@/api/login";
import { setUserInfo } from "@/store/actions";
import "./index.less";

const SetPassword = (props) => {
    const { form, history, user, setUserInfo } = props;
    const { getFieldDecorator } = form;
    const [loading, setLoading] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        form.validateFields(async (err, values) => {
            if (!err) {
                setLoading(true);
                try {
                    const { password, confirmPassword } = values;
                    const response = await reqSavePassword({ password, confirmPassword });
                    if (response && response.status === 0) {
                        message.success("密码设置成功，正在进入系统...");

                        // 重要：更新 Redux 状态，清除强制重定向标识
                        setUserInfo({ ...user, needPassword: false });

                        // 设置成功后跳转到首页
                        history.push("/dashboard");
                    } else {
                        message.error(response.message || "设置失败");
                    }
                } catch (error) {
                    message.error("设置密码出错，请稍后重试");
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    return (
        <DocumentTitle title={"设置密码"}>
            <div className="set-password-container">
                <Form onSubmit={handleSubmit} className="content">
                    <div className="title">
                        <h2>初次登录请设置密码</h2>
                        <p className="account-info">
                            您的登录账号为：<strong>{user.name}</strong>
                        </p>
                    </div>
                    <Spin spinning={loading} tip="正在保存...">
                        <Form.Item label="新密码">
                            {getFieldDecorator("password", {
                                rules: [
                                    { required: true, message: "请输入新密码" },
                                    { min: 6, message: "密码长度不能少于6位" }
                                ],
                            })(
                                <Input
                                    prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
                                    type="password"
                                    placeholder="新密码"
                                />
                            )}
                        </Form.Item>
                        <Form.Item label="确认密码">
                            {getFieldDecorator("confirmPassword", {
                                rules: [
                                    { required: true, message: "请再次输入新密码" },
                                    {
                                        validator: (rule, value, callback) => {
                                            if (value && value !== form.getFieldValue("password")) {
                                                callback("两次输入的密码不一致");
                                            } else {
                                                callback();
                                            }
                                        }
                                    }
                                ],
                            })(
                                <Input
                                    prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
                                    type="password"
                                    placeholder="确认密码"
                                />
                            )}
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="set-password-form-button"
                                loading={loading}
                                block
                            >
                                保存并登录
                            </Button>
                        </Form.Item>
                    </Spin>
                </Form>
            </div>
        </DocumentTitle>
    );
};

const WrapSetPassword = Form.create()(SetPassword);
export default connect((state) => ({ user: state.user }), { setUserInfo })(withRouter(WrapSetPassword));
